export * from './CimSchemaGenerated';
export * from './CimOperationsGenerated';
import possibleTypes from './CimOperationsGenerated';
export default possibleTypes;

type MergeUnionOfObjects<
  T,
  CommonKeys extends PropertyKey = keyof T,
  AllKeys extends PropertyKey = T extends unknown ? keyof T : never,
  NonCommonKeys extends PropertyKey = Exclude<AllKeys, CommonKeys>
> = {
  [P in CommonKeys]: Merged<T extends unknown ? (P extends keyof T ? T[P] : never) : never>;
} & {
  [P in NonCommonKeys]?: Merged<T extends unknown ? (P extends keyof T ? T[P] : undefined) : never>;
};

type MergeObjects<T> = [T] extends [never]
  ? never
  : [T] extends [ReadonlyArray<unknown>]
    ? Array<Merged<T[number]>>
    : [T] extends [(...args: never[]) => unknown]
      ? T
      : [T] extends [object]
        ? MergeUnionOfObjects<T>
        : T;

/** Recursively merges a union of objects into a single object type with all properties as optional. */
export type Merged<T> = MergeObjects<Extract<T, object>> | Exclude<T, object>;



import {
  TapestryGenerationProfileInfoQuery,
  TapestryGeneratorInfoQuery,
  TapestryStorageInfoQuery,
  FetchMapTypedObjectsQuery,
  SearchAssetsQuery,
  BusbarSectionsBySubstationsQuery,
  FetchEnergyStorageDetailsQuery,
  FetchGeneratorDetailsQuery,
  TapestryBranchInfoQuery,
  FetchTransformerDetailsQuery,
  FetchTransmissionLineDetailsQuery,
  FetchAssetLimitsDetailsQuery,
  TransformersByBusbarsQuery,
  FetchReducedBranchDetailsQuery,
  FetchReducedBusDetailsQuery,
  FetchSubstationDetailsQuery,
  BusbarSectionsByIdsQuery,
  FetchReducedBranchDetailsByIdQuery,
  FetchReducedBusDetailsByIdQuery,
  GeneratorsByBusbarSectionsQuery,
  SubGeographicalRegionsQuery,
} from './CimOperationsGenerated';

export type TapestryGeneratorInfoQueryViewObjects = Merged<
  TapestryGeneratorInfoQuery['viewObjects']['viewObjects'][number]
>;
export type TapestryGenerationProfileInfoQueryViewObjects = Merged<
  TapestryGenerationProfileInfoQuery['viewObjects']['viewObjects'][number]
>;
export type TapestryStorageInfoQueryViewObjects = Merged<
  TapestryStorageInfoQuery['viewObjects']['viewObjects'][number]
>;
export type FetchMapTypedObjectsQueryEntities = Merged<
  FetchMapTypedObjectsQuery['energySystemEntities']['entities'][number]
>;
export type SearchAssetsQueryEntities = Merged<
  SearchAssetsQuery['energySystemEntities']['entities'][number]
>;
export type BusbarSectionsBySubstationsQueryEntities = Merged<
  BusbarSectionsBySubstationsQuery['energySystemEntities']['entities'][number]
>;
type SubstationType = Extract<
  BusbarSectionsBySubstationsQuery['energySystemEntities']['entities'][number],
  {__typename: 'Substation'}
>;
export type BusbarSectionsBySubstationsQueryBusbar = Extract<
  SubstationType['voltageLevels'][number]['busbars'][number],
  {__typename: 'BusbarSection'}
>;
export type FetchEnergyStorageDetailsQueryStorage = Merged<
  FetchEnergyStorageDetailsQuery['energySystemEntities']['storage'][number]
>;
export type FetchGeneratorDetailsQueryGenerator = Merged<
  FetchGeneratorDetailsQuery['energySystemEntities']['generator'][number]
>;
export type TapestryBranchInfoQueryViewObjects = Merged<
  TapestryBranchInfoQuery['viewObjects']['viewObjects'][number]
>;
export type FetchTransformerDetailsQueryTransformer = Merged<
  FetchTransformerDetailsQuery['energySystemEntities']['transformer'][number]
>;
export type FetchTransmissionLineDetailsQueryLine = Merged<
  FetchTransmissionLineDetailsQuery['energySystemEntities']['line'][number]
>;
export type FetchAssetLimitsDetailsQueryEntities = Merged<
  FetchAssetLimitsDetailsQuery['energySystemEntities']['entities'][number]
>;
export type TransformersByBusbarsQueryEntities = Merged<
  TransformersByBusbarsQuery['energySystemEntities']['entities'][number]
>;
export type FetchReducedBranchDetailsQueryReducedBranch = Merged<
  FetchReducedBranchDetailsQuery['energySystemEntities']['reducedBranch'][number]
>;
export type FetchReducedBusDetailsQueryReducedBus = Merged<
  FetchReducedBusDetailsQuery['energySystemEntities']['reducedBus'][number]
>;
export type FetchSubstationDetailsQuerySubstation = Merged<
  FetchSubstationDetailsQuery['energySystemEntities']['substation'][number]
>;
export type BusbarSectionsByIdsQueryEntities = Merged<
  BusbarSectionsByIdsQuery['energySystemEntities']['entities'][number]
>;
export type FetchReducedBranchDetailsByIdQueryReducedBranch = Merged<
  FetchReducedBranchDetailsByIdQuery['energySystemEntities']['reducedBranch'][number]
>;
export type FetchReducedBusDetailsByIdQueryReducedBus = Merged<
  FetchReducedBusDetailsByIdQuery['energySystemEntities']['reducedBus'][number]
>;

export type GeneratorsByBusbarSectionsQueryEntities = Merged<
  GeneratorsByBusbarSectionsQuery['energySystemEntities']['entities'][number]
>;

export type SubGeographicalRegionsQueryEntities = Merged<
  SubGeographicalRegionsQuery['energySystemEntities']['entities'][number]
>;
